<template>
  <div>
	  <Header :sel='3' @changePhone="changePhone"/>
	  <div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
	    <!-- your content here --> 
	    <!--banner-->
	    <div class="banner">
	      <div class="banner_txt">
	        <p><strong>News Center</strong></p>
	        <p>新闻中心</p>
	      </div>
	    </div>
	    <!--banner--> 
	    
	    <!--neirong-->
	    <div class="neirong"> 
	      <!--left-->
	      
	      <div class="bread"> <a href="javascript:void(0)" @click="goNext('/')">首页</a> - <a href="javascript:void(0)">新闻中心</a> - <a href="javascript:void(0)">{{selName}}</a></div>
	      <div class="neirong_c">
	       <ul class="erji_tab">
	          <li><a href='javascript:void(0)' :class="type==1001?'sel10':''" @click="selData('1001','公司新闻')">公司新闻</a></li>
	          <li><a href='javascript:void(0)' :class="type==1002?'sel10':''" @click="selData('1002','行业新闻')">行业新闻</a></li>
	        </ul>
	  
	        <ul class="news_list">
	          <li v-for="item in list">
	            <div class="news_l"><a href="javascript:void(0);" @click="goDetail(item.id)"><img :src="item.image" /></a></div>
	            <div class="news_r">
	              <p>{{item.createTime}} {{item.cmsCategory.categoryName}}</p>
	              <div class="news_r_t"><a href="javascript:void(0);" @click="goDetail(item.id)">{{item.title}}</a></div>
	              <div class="news_r_c">{{item.describtion}}</div>
	            </div>
	            <div class="clear"></div>
	          </li>
	          
	        </ul>
	        <ul id="page">
	            <li><a href="javascript:void(0)" @click="goPage('home')">首页</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('last')">上一页</a></li>
	            <li v-for="index in indexs" @click="goPage(index)"><a :class="pageNum==index?'pagesel':''" href="javascript:void(0)">{{index}}</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('next')">下一页</a></li>
	            <li><a href="javascript:void(0)" @click="goPage('end')">尾页</a></li>
	            <li class="total">共{{totalPage}}页</li>
	        </ul>
	      </div>
	    </div>
	         <Footer></Footer> 
	   
	  </div>
	  
    
  </div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import{getHelpType,articleList} from '@/api/reqFetch.js'
  export default {
  	name: '',
    layout: '',
	components: {
	  Footer,
	  Header
	},
  	data() {
  		return {
			tabList:[],
			selName:'全部新闻',
			selid:'0',
			list:[],
			pageNum: 1,
			indexs: [],
			totalPage: 0,
			showPhone:false,
			type:''
		}
  	},

  	mounted() {
		if(this.$route.query.type){
			this.type=this.$route.query.type
			this.selName=this.$route.query.type=='1001'?'公司新闻':'行业新闻'
		}
	  this.getData()
  	},

  	methods: {
		changePhone(val){
			this.showPhone=val
		},
		goNext(url){
			this.$router.push({
				path:url,
			})
		},
		selData(id,name){
			this.selName=name
			this.type=id;
			this.getData()
		},
		checkIndex() {
		    var left = 1;
		    var right = this.totalPage;
		    var ar = [];
		    if (this.totalPage >= 3) {
		        if (this.pageNum > 1 && this.pageNum < this.totalPage - 2) {
		            left = this.pageNum - 1
		            right = this.pageNum + 1
		        } else {
		            if (this.pageNum <= 1) {
		                left = 1
		                right = 3
		            } else {
		                right = this.totalPage
		                left = this.totalPage - 2
		            }
		        }
		    }
		    while (left <= right) {
		        ar.push(left)
		        left++
		    }
		    this.indexs = ar
		
		},
		goPage(type) {
		    if (type == 'home') {
		        this.pageNum = 1
		    } else if (type == 'end') {
		        this.pageNum = Number(this.totalPage)
		
		    } else if (type == 'last') {
		        if (this.pageNum > 1) {
		            this.pageNum = this.pageNum - 1
		        }
		    } else if (type == 'next') {
		        if (this.pageNum < (this.totalPage)) {
		            this.pageNum = this.pageNum + 1
		        }
		    } else {
		        this.pageNum = type
		    }
		    this.getData()
		},
		init(){
			//this.params.pageNumber=1;
			this.getData()
		},
		getData(){
			let par={
				pageNum: this.pageNum,
				pageSize: 5,
				
			}
			if(this.type){
				par.categoryCode=this.type
			}
			articleList(par).then(res => {
			  this.list = res.rows;
			  this.totalPage = Math.ceil(res.total / 5)
			  this.checkIndex();
			});
		},
		goDetail(id){
			this.$router.push({
				path:'/context',
				query:{id:id}
			})
		}
     
  	}
  }
</script>

<style scoped>
	.banner{
		background-image: url('../../assets/images/banner_03.png');
	}


</style>
